export enum LogoButtonEnum {
  LogoGreen,
  LogoGreyWithText,
  LogoGreenWithText,
}
